export default __webpack_public_path__ + "static/media/FB.499d4774.svg";